import { render } from "./TagSelector.vue?vue&type=template&id=0ba7eddd&scoped=true"
import script from "./TagSelector.vue?vue&type=script&lang=js"
export * from "./TagSelector.vue?vue&type=script&lang=js"

import "./TagSelector.vue?vue&type=style&index=0&id=0ba7eddd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba7eddd"]])

export default __exports__